import React from "react";
const IconAccount = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="M18 18.05h.05V17.2a4.85 4.85 0 0 0-4.85-4.85H6.8a4.85 4.85 0 0 0-4.85 4.85V18.05H18ZM12.35 6.4c0 1.558-1.094 2.75-2.35 2.75S7.65 7.958 7.65 6.4 8.744 3.65 10 3.65s2.35 1.192 2.35 2.75Zm-6.4 0c0 2.453 1.809 4.45 4.05 4.45 2.241 0 4.05-1.997 4.05-4.45 0-2.453-1.809-4.45-4.05-4.45-2.241 0-4.05 1.997-4.05 4.45Zm-2.184 9.95a3.151 3.151 0 0 1 3.034-2.3h6.4c1.445 0 2.663.973 3.034 2.3H3.766Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".1"
    />
  </svg>
);
export default IconAccount;
